import script from "./FlexCarouselEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./FlexCarouselEditor.vue?vue&type=script&setup=true&lang=js"

import "./FlexCarouselEditor.vue?vue&type=style&index=0&id=0f424160&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3624/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f424160"]])

export default __exports__